import React, { FC } from 'react';
import { ListCards } from '@/components/molecules/ListCards/render';

import block from './block.json';

/**
 * COMPONENT
 */
export const ListFeatures: FC<ListCardsProps> & BlockConfigs = (props) => {
	return <ListCards {...props} />;
};

ListFeatures.slug = block.slug;
ListFeatures.title = block.title;
